import ClaimsChart from "./ClaimsChart";
import { Stack } from "@mui/material";
import BigLoader from "components/common/BigLoader";
import * as labels from "config.labels";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as claimsService from "services/claimsService";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as exposureSelectors from "store/selectors/input/exposure/exposureSelectors";

const ClaimsChartAggregateLossByLine = ({ claimsQuery, hideDevelopment }) => {
  const lineMapping = useSelector(exposureSelectors.selectLossCategories);

  const getLineDisplay = (name) => {
    if (lineMapping) {
      for (const i in lineMapping) {
        if (lineMapping[i].key === name) return lineMapping[i].display;
      }
    }
    return name;
  };

  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const {
    data: chartsByLine,
    isFetching: chartsByLineIsFetching,
    error: chartsByLineError,
  } = claimsService.useAggregateLossByLineChartsQuery(claimsQuery);
  const [maxVal, setMaxVal] = useState(0);
  useEffect(() => {
    if (!chartsByLineIsFetching && !chartsByLineError) {
      const max = (chartsByLine?.charts || [])
        .map((chart) => chart?.chart?.data || [])
        .flatMap((a) => a)
        .reduce((acc, val) => Math.max(acc, val.ultimate, val.value), 0.0);
      setMaxVal(max);
    }
  }, [chartsByLine?.charts, chartsByLineError, chartsByLineIsFetching]);

  if (chartsByLineIsFetching)
    return (
      <Stack
        sx={{
          backgroundColor: "white",
          width: "100%",
          margin: "20px 0 0 23px",
        }}
      >
        <BigLoader />
      </Stack>
    );
  if (chartsByLineError) return <></>;
  return (
    <>
      {(chartsByLine?.charts || []).map((chart, i) => (
        <ClaimsChart
          key={chart?.line ?? i}
          title={
            translateLabel(labels.LOSS_AGGREGATE_BY_LINE_TITLE, {
              default: "Loss Aggregate",
            }) +
            ": " +
            getLineDisplay(chart?.line)
          }
          subtitle={
            translateLabel(labels.LOSS_AGGREGATE_BY_LINE_SUBTITLE, {
              default: "Total loss per year for line ",
            }) + getLineDisplay(chart?.line)
          }
          chart={chart?.chart}
          loading={chartsByLineIsFetching}
          error={chartsByLineError}
          dataName={translateLabel(labels.AGGREGATE_DATA_NAME, {
            default: "Aggregate",
          })}
          ultimateName={
            hideDevelopment
              ? null
              : translateLabel(labels.DEVELOPMENT_AND_INFLATION, {
                  default: "Development & Inflation",
                })
          }
          minYMax={maxVal}
        />
      ))}
    </>
  );
};

export default ClaimsChartAggregateLossByLine;
